import { OFFERS_BASE_QUERY_URL_CONFIG_KEY } from '../constants/config';
import { useApplicationContext } from '../utils/applicationContext';

export const useOffersListingUrl = (newbuildingIds: number[]): string => {
  const { config } = useApplicationContext();

  const baseQueryUrl = config.getStrict<string>(OFFERS_BASE_QUERY_URL_CONFIG_KEY);

  const newobjectParams = newbuildingIds.map((id, index) => `newobject[${index}]=${id}`).join('&');

  return `${baseQueryUrl}&${newobjectParams}`;
};
